module.exports = __webpack_public_path__ + "assets/04b1f4abc2de81e98a74f1bcb442e932.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/sounds/win/win_2.mp3
 ** module id = 58
 ** module chunks = 0
 **/